<template>
    <div :class="getClass">
        <slot></slot>
        <div v-for="(rule, i) in getActiveRules"
             :id="id" :key="'rule-' + i"
             class="ui basic red pointing prompt label transition scale in" style="animation-duration: 200ms;">
            {{rule.msg}}
        </div>
    </div>
</template>

<script>
export default {
  props: {
    // Trigger to show the validation errors
    showErrorsOn: {
      type: Boolean,
      default: false
    },
    // Has this particular field any errors (in all the rules defined for it)
    hasAnyErrors: {
      type: Boolean,
      default: false
    },
    /* Validation rules of this field (each rule is an object consisting of:
            - value (current value of the validation - true = input is valid / false = input is not valid - mandatory),
            - msg (the error message to show for this validation -  mandatory),
            - showOn (condition, when to show the error for this validation - optional) */
    validationRules: {
      type: Array,
      default: function () {
        return []
      }
    },
    // Additional css classes for the field element (space separated)
    additionalClasses: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      defaultClass: 'field',
      errorClass: 'field error'
    }
  },
  computed: {
    getClass: function () {
      const baseClass = this.additionalClasses ? ' ' + this.additionalClasses : ''

      if (this.showErrorsOn && this.hasAnyErrors) return this.errorClass + baseClass

      return this.defaultClass + baseClass
    },
    getActiveRules: function () {
      const showErrors = this.showErrorsOn
      return this.validationRules.filter(function (rule) {
        return showErrors && (rule.showOn !== undefined ? rule.showOn : true) && !rule.value
      })
    }
  }
}
</script>

<style scoped>
    .ui.basic.red.pointing.prompt.label.transition.scale.in {
        margin-left: 0;
        margin-right: 0;
    }
</style>
